<template>
  <c-modal
    is-opened
    fullscreen
    no-bottom-shadow
    position='right'
    title="Filtrar"
    class="c-filter-modal"
    data-testid="filter-modal"
    @close="$emit('close')"
  >
    <div class="clear-button-wrapper">
      <c-button
        ref="clear-filters"
        flat
        class="clear-filters"
        :disabled="isLoading || hasFilters"
        @click="onClear"
      >
        Limpar Filtros
      </c-button>
    </div>

    <c-form-builder
      ref="form"
      v-if="!isLoading"
      name="filter-modal-form"
      no-actions
      show-overflow
      no-bottom-shadow
      no-upper-shadow
      :revalidate-on-input="revalidateOnInput"
      :schema="filterSchema"
      :show-errors-when-changed="showErrorsWhenChanged"
      :fields-options="optionsSchema"
      :value="value"
      :model-value="value"
      @input="onChange"
      @update:modelValue="onChange"
    >
      <template
        v-for="slot in scopedSlots"
        :slot="slot"
        slot-scope="fieldProps"
      >
        <slot :name="slot" v-bind="fieldProps" />
      </template>

      <template v-for="(_, fieldName) in filterSchema">
        <slot :slot="`${fieldName}-divider`" :name="`${fieldName}-divider`" />
      </template>
    </c-form-builder>

    <c-loader v-else />
  </c-modal>
</template>

<script>
import CModal from '@convenia/components/CModal'
import CButton from '@convenia/components/CButton'
import { CFormBuilder } from '@convenia/components/CFormBuilder'
import CLoader from '@convenia/components/CLoader'

export default {
  name: 'CFilterModal',

  components: { CModal, CButton, CFormBuilder, CLoader },

  props: {
    filterSchema: {
      type: Object,
      default: () => ({})
    },
    value: {
      type: Object,
      default: () => ({})
    },
    optionsSchema: {
      type: Object,
      default: () => ({})
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    showErrorsWhenChanged: {
      type: Boolean,
      default: false
    },
    revalidateOnInput: {
      type: Boolean,
      default: false
    }
  },

  emits: [
    'input',
    'filter',
    'clear',
    'close',
    'update:modelValue'
  ],

  computed: {
    hasFilters () {
      return Object.keys(this.value).length === 0
    },

    scopedSlots () {
      return Object.keys(this.filterSchema || {}).filter(key => this.filterSchema[key].type === 'slot'
      ).map(name => `${name}-slot`)
    },
  },

  methods: {
    onClear () {
      this.$emit('input', {})
      this.$emit('update:modelValue', {})
      this.$emit('filter', {})
      this.$emit('clear')
    },

    onChange (formData) {
      if (this.showErrorsWhenChanged)
        this.$nextTick(() => this.$refs.form?.showValidations())

      this.$emit('input', formData)
      this.$emit('update:modelValue', formData)
      this.$emit('filter', formData)
    }
  },
}
</script>

<style lang="scss">
.c-filter-modal {
  &.c-modal > .wrapper > .modal {
    height: 100vh;
    width: 100%;
    border-radius: 0;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    overflow: unset;

    & > .content {
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      overflow-y: auto;
      scrollbar-width: none;
      height: 100%;

      & > .clear-button-wrapper {
        width: 100%;

        & > .clear-filters {
          width: 100%;
          margin-bottom: 20px;
        }
      }

      & > .c-loader {
        padding-top:50px;
        align-self: center;
      }

      & > .c-form-builder
      > .c-shadowed > .wrapper > .form-fields {
        padding: 0 ;
        height: calc(100% - 155px);
        display: flex;
        flex-direction: column;

        & > .c-form-field {
          grid-template-columns: calc(100%);

          &.multi-select { margin-bottom: 20px; }
        }

        & > .divider { margin: 10px 0; }
      }
    }
  }

  @include responsive (xs-mobile, mobile) {
    &.c-modal > .wrapper.-fullscreen.-right > .modal {
      width: 100%;
      position: absolute;

      & > .header {
        padding: 10px;

        & > .title {
          margin-left: 10px;
          margin-top: 5px;
        }
      }

      & > .content > .clear-button-wrapper > .clear-filters {
        margin-top: 0;
      }

      & > .content > .item > .label { margin-left: 10px; }
    }
  }

  @include responsive (tablet, desktop) {
    &.c-modal > .wrapper.-fullscreen.-right {
      left: initial;
      width: fit-content;

      & > .modal {
        width: 400px;
        max-width: unset;
      }
    }
  }
}
</style>
